"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GiftIcon = void 0;
var _icons = require("@ori-ui/icons");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _sponsorContext = require("../../context/sponsorContext");
var _useTranslations = require("../../hooks/useTranslations");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const GiftIcon = () => {
  const {
    animate,
    handleClickSponsorBanner,
    isGiftIconVisible
  } = (0, _sponsorContext.useSponsor)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  if (!isGiftIconVisible) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MenuIconRoot, {
    "data-testid": getTestId(_constants.GIFT_ICON),
    animate: animate,
    title: translations.viewWelcomeGiftInformation,
    onClick: handleClickSponsorBanner,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Gift, {})
  });
};
exports.GiftIcon = GiftIcon;